import { useState } from "react";
import { IconButton, Link, Tooltip, Typography } from "@mui/joy";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "../i18n";
import OpenInNewRounded from "@mui/icons-material/OpenInNewRounded";
import { Link as RouterLink } from "react-router-dom";

export interface InspectionRefProps {
  inspectionRef: string;
  teamSlug: string;
  openInNewWindow?: boolean;
  copy?: boolean;
}

export default function InspectionRef({
  inspectionRef,
  copy,
  teamSlug,
  openInNewWindow,
}: InspectionRefProps) {
  const t = useTranslation();
  const [copied, setCopied] = useState<string | null>(null);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(inspectionRef);
    setCopied(inspectionRef);
    setTimeout(() => setCopied(null), 200);
  };
  const short =
    inspectionRef.slice(0, 3) +
    ".." +
    inspectionRef.slice(inspectionRef.length - 3, inspectionRef.length);
  return (
    <Typography
      sx={{ display: "unset" }}
      fontSize={12}
      startDecorator={
        copy && (
          <Tooltip arrow title={<Typography>{t("Copy Ref #")}</Typography>}>
            <IconButton
              size="sm"
              variant={copied === inspectionRef ? "solid" : "plain"}
              color={copied === inspectionRef ? "success" : "neutral"}
              onClick={handleCopyToClipboard}
            >
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        )
      }
    >
      <Link
        component={RouterLink}
        to={`/${teamSlug}/inspections/${inspectionRef}`}
        target={openInNewWindow ? "_blank" : ""}
        endDecorator={openInNewWindow ? <OpenInNewRounded /> : null}
        sx={{ fontFamily: "monospace" }}
      >
        {short.toUpperCase()}
      </Link>
    </Typography>
  );
}
